export default "__VITE_ASSET__s$InM$mX__"